import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';
import { getSlugFilterStructure } from '@core/Utils/Search/GetSlugFilterStructure';
import { getFilterFromSlugItem } from '@core/Utils/SearchFilters/GetFilterFromSlugItem';

import type { FilterParams, SlugParamKey } from '../../../Entities/Search/QueryParams.entity';
import { getLocationFromSlug } from './GetLocationFromSlug';
import { getMmvFiltersFromSlug } from './GetMmvFiltersFromSlug';

export const filtersSlugToParams = async (slug: string[] | undefined, root: PlpRoot) => {
  if (!slug?.length) return {};

  let outputFilters: FilterParams = {};
  let otherSlugFilters = [...slug];

  //is there a location id? If yes, take information as filters and remove from array
  const locFilters = await getLocationFromSlug(otherSlugFilters[0]);
  outputFilters = {
    ...(locFilters.area ? { area: locFilters.area } : {}),
  };

  //locFilter may contains multiple filters, but there is only one slug part to remove
  const removeLocIndex = Object.keys(locFilters).length > 0 ? 1 : 0;
  otherSlugFilters = otherSlugFilters.slice(removeLocIndex);

  //is there a MMV group? If yes, take information as filters and remove from array
  const mmvFilters = await getMmvFiltersFromSlug(otherSlugFilters);
  outputFilters = {
    ...outputFilters,
    ...mmvFilters,
  };

  otherSlugFilters = otherSlugFilters.slice(Object.keys(mmvFilters).length);

  //loop though what's left and check if it matches the allowed sug keys and order
  const slugFiltersOrdered = getSlugFilterStructure();
  let slugItemIndex = 0;

  const slugFiltersOrderedKeys = Object.keys(slugFiltersOrdered);
  for (let i = 0; i < slugFiltersOrderedKeys.length; i++) {
    const filterKey = slugFiltersOrderedKeys[i];
    const filterOptions = slugFiltersOrdered[filterKey as keyof typeof slugFiltersOrdered];

    const slugItem = otherSlugFilters[slugItemIndex];
    if (slugItem === undefined) break;

    const isSlugItemInCurrentFilter = filterOptions.includes(slugItem);
    //we have to allow any price in the url, but will use canonical to set specific prices
    const isPriceMax = filterKey === 'price' && slugItem.includes('under-');

    const isPage = filterKey === 'page' && slugItem.includes('page-');

    if (isSlugItemInCurrentFilter || isPriceMax || isPage) {
      const filterObj = getFilterFromSlugItem(slugItem, filterKey as SlugParamKey, root);

      outputFilters = {
        ...outputFilters,
        ...filterObj,
      };
      slugItemIndex++;
    }
  }

  return outputFilters;
};
